class PincodeChecker extends HTMLElement {
    constructor() {
      super();
      this.pincodeInput = null;
      this.pincodeSubmitBtn = null;
      this.pincodeMessage = null;
      this.sku = this.dataset.sku;
    }

    connectedCallback() {
      requestAnimationFrame(() => {
        this.pincodeInput = this.querySelector('[name="pincode-input"]');
        this.pincodeSubmitBtn = this.querySelector('[name="pincode-submit"]');
        this.pincodeMessage = this.querySelector('[name="pincode-message"]');

        if (!this.pincodeInput || !this.pincodeSubmitBtn || !this.pincodeMessage) {
          return;
        }

        this.loadLastPincodeOrFetchFromIP();

        this.pincodeSubmitBtn.addEventListener('click', this.validatePincode.bind(this));
        this.pincodeInput.addEventListener('focus', this.moveCursorToEnd.bind(this));
        this.pincodeInput.addEventListener('keypress', this.validateInput.bind(this));
        this.pincodeInput.addEventListener('keydown', this.handleBackspace.bind(this));

        this.pincodeInput.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            this.validatePincode();
          }
        });
      });
    }

    validatePincode() {
      const pincode = this.pincodeInput.value.trim();
      if (pincode.length === 6) {
        this.fetchEstimatedDeliveryFromAPI(pincode, this.sku);
      } else {
        this.showError("Please enter a valid pincode");
      }
    }

    async loadLastPincodeOrFetchFromIP() {
      if (!this.pincodeInput) return;

      const lastPincode = localStorage.getItem("lastPincode");

      if (lastPincode && lastPincode.length === 6) {
        this.pincodeInput.value = lastPincode;
        this.validatePincode();
        return;
      }

      try {
        const res = await fetch("https://ipapi.co/json/", {
          method: "GET",
          headers: {
            "Accept": "application/json"
          }
        });

        if (!res.ok) {
          return;
        }

        const data = await res.json();
        const ipPincode = (data.postal || "").toString().trim();

        if (ipPincode && ipPincode.length === 6) {
          this.pincodeInput.value = ipPincode;
          localStorage.setItem("lastPincode", ipPincode);
          this.validatePincode();
        }
      } catch (err) {
       
      }
    }

    fetchEstimatedDeliveryFromAPI(pincode, sku) {
      const apiUrl = `https://api.openleaf.tech/api/v1/custom_pincodes/closestTATUnicommerce?pincode=${pincode}&sku=${sku}`;

      fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Authorization': 'Bearer 025f23eaa925b4471e46d57cd3367b77'
        }
      })
      .then(response => response.json())
      .then(result => {
        const values = result?.values;

        if (values && values.length >= 4 && values[2] === 'true') {
          let estimatedDayResponse = parseInt(values[0]) + 2;
          let estimatedDate = new Date();
          estimatedDate.setDate(estimatedDate.getDate() + estimatedDayResponse);

          if (estimatedDate.getDay() === 0) {
            estimatedDate.setDate(estimatedDate.getDate() + 1);
          }

          let estimatedDeliveryDate = estimatedDate.toLocaleDateString("en-IN", {
            weekday: 'short',
            day: 'numeric',
            month: 'short'
          });

          const successHtml = `
            <div class="pincode-message__item">
              <div class="pincode-message__item-container">
                <p><strong>Estimated Delivery By:</strong> ${estimatedDeliveryDate}</p>
              </div>
            </div>`;

          this.pincodeMessage.innerHTML = successHtml;
          this.pincodeMessage.classList.add('is-success');
          this.pincodeMessage.classList.remove('is-error', 'is-hidden');

          localStorage.setItem("lastPincode", pincode);
        } else {
          this.showError("Delivery info not available for this pincode.");
        }
      })
      .catch(() => {
        this.showError("Unable to fetch delivery info.");
      });
    }

    showError(message) {
      this.pincodeMessage.textContent = message;
      this.pincodeMessage.classList.add('is-error');
      this.pincodeMessage.classList.remove('is-success', 'is-hidden');
    }

    moveCursorToEnd() {
      const val = this.pincodeInput.value;
      this.pincodeInput.value = '';
      this.pincodeInput.value = val;
    }

    validateInput(e) {
      if (!/[0-9]/.test(e.key)) {
        e.preventDefault();
      }
    }

    handleBackspace(e) {
      if (e.key === 'Backspace' && this.pincodeInput.value.length === 0) {
        e.preventDefault();
      }
    }
  }

  customElements.define('pincode-checker', PincodeChecker);


